<div [ngClass]="classNames()" >
    <ng-content></ng-content>
</div>
